<div class="palantir-pagination">
  @if (layout === 'default') {
    <div class="palantir-pagination__items-per-page">
      <palantir-text type="description" size="xs">{{ perPageLabel }}</palantir-text>

      <div class="palantir-pagination__items-per-page-button" [cdkMenuTriggerFor]="menu">
        <palantir-text type="description" size="xs">{{ service.take() }}</palantir-text>

        <palantir-icon name="arrow-drop-down-outline" />
      </div>

      <ng-template #menu>
        <palantir-content class="palantir-menu" cdkMenu layout="no-padding">
          @for (option of paginationOptions(); track option) {
            <palantir-button
              theme="transparent"
              size="xs"
              [attr.variant]="option === service.take() ? 'positive' : 'neutral'"
              (click)="changePaginationSize(option)"
            >
              {{ option }}
            </palantir-button>
          }
        </palantir-content>
      </ng-template>
    </div>
  }

  <div class="palantir-pagination__navigation">
    <palantir-text type="description" size="xs">{{ pageRange() }}</palantir-text>

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="isFirstPageDisabled()"
      icon="first-page-outline"
      (click)="firstPage()"
      [palantirTooltip]="firstPageLabel"
    >
      {{ firstPageLabel }}
    </palantir-button>

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="isFirstPageDisabled()"
      icon="chevron-left-outline"
      (click)="previousPage()"
      [palantirTooltip]="previousPageLabel"
    >
      {{ previousPageLabel }}
    </palantir-button>

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="isLastPageDisabled()"
      icon="chevron-right-outline"
      (click)="nextPage()"
      [palantirTooltip]="nextPageLabel"
    >
      {{ nextPageLabel }}
    </palantir-button>

    <palantir-button
      layout="icon"
      theme="outline"
      [attr.disabled]="isLastPageDisabled()"
      icon="last-page-outline"
      (click)="lastPage()"
      [palantirTooltip]="lastPageLabel"
    >
      {{ lastPageLabel }}
    </palantir-button>
  </div>
</div>
